<template>
  <RotateFrame>
  <div id="withdraw-history" ref="scrollBox">
    <div class="header">
      <img class="left-icon" src="/assets/arrow_left.png" @click="backToHome">
      <span class="title">Withdraw History</span>
      <span class="placeholder"></span>
    </div>

    <div class="tabs-container" v-if="showUsdtTab || showCardTab">
      <div class="tab-item" :class="{ active: tabType === 3 }" @click="switchTab(3)">
        PayPal
      </div>
      <div class="tab-item" :class="{ active: tabType === CARD_TYPE }" @click="switchTab(CARD_TYPE)" v-if="showCardTab">
        Card
      </div>
      <div class="tab-item" :class="{ active: tabType === 4 }" @click="switchTab(4)" v-if="showUsdtTab">
        USDT
      </div>
    </div>

    <div class="data-container">
      <div v-if="withdrawList && withdrawList.length > 0">
        <div class="data-item" v-for="(item, index) in withdrawList" :key="index">
          <div>
            <img class="item-f" src="/assets/withdraw-us/his-success.png" v-if="item.status === 4" />
            <img class="item-f" src="/assets/withdraw-us/his-failed.png" v-else-if="item.status === 3 || item.status === 0" />
            <img class="item-f" src="/assets/withdraw-us/his-sending.png" v-else-if="item.status === 2" />
            <img class="item-f" src="/assets/withdraw-us/his-sending.png" v-else-if="item.status === 1" />
          </div>

          <div class="item-2">
            <span class="item-2-1">${{item.amount}}</span>
            <div class="item-2-2">
              <span class="item-2-2-1">Balance</span>
              <span class="item-2-2-2">${{item.amount}}</span>
            </div>
          </div>

          <div class="line"></div>

          <div class="item-data">
            <div class="item-data-1">
              <span class="item-2-2-1">{{ tabType === CARD_TYPE ? 'Withdrawal Card' : 'Withdrawal Account' }}</span>
              <span class="item-2-2-2" v-if="tabType === 3">{{formatEmail(item.account)}}</span>
              <span class="item-2-2-2" v-else-if="tabType === CARD_TYPE">{{formatCard(item.account)}}</span>
              <span class="item-2-2-2" v-else>{{formatedDisplayAddress(item.account)}}</span>
            </div>

            <div class="item-data-1" v-if="tabType === 4">
              <span class="item-2-2-1">Network</span>
              <span class="item-2-2-2">Tron(TRC20)</span>
            </div>

            <div class="item-data-1">
              <span class="item-2-2-1">Amount Received</span>
              <span class="item-2-2-2" style="color: #FFA100" v-if="tabType === 4">${{item.settle}}</span>
              <span class="item-2-2-2" style="color: #FFA100" v-else>${{item.amount}}</span>
            </div>

            <div class="item-data-1">
              <span class="item-2-2-1">Withdrawal At</span>
              <span class="item-2-2-2">{{item.created}}</span>
            </div>

            <div class="item-data-1">
              <span class="item-2-2-1" v-if="tabType === 4">Transaction hash</span>
              <span class="item-2-2-1" v-else>Order Number</span>
              <div>
                <span class="item-2-2-2">{{item.withdrawId}}</span>
                <img class="copy" src="/assets/withdraw-us/his-copy.png" @click="copy(item.withdrawId)" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <img v-else src="/assets/withdraw-us/no-withdrawal-history.png" class="no-withdraw" />
    </div>
  </div>
  </RotateFrame>
</template>

<script>
import { postRequest, toast } from '@/utils/withdrawApi'
import withdrawRem from './withdrawRem'
import RotateFrame from './RotateFrame.vue'

export default {
  components: { RotateFrame },
  mixins: [withdrawRem],
  data () {
    return {
      s: null,
      withdrawList: [],
      tabType: 3, // 3 paypal 4 usdt 5 card
      page: 1,
      size: 10,
      loading: false,
      finished: false,
      showUsdtTab: false,
      showCardTab: false,
      // TODO: Card 的 paymentType 待后端确认，与 withdraw-us.vue 的 CARD_TYPE 保持一致
      CARD_TYPE: 5
    }
  },
  methods: {
    formatEmail (email) {
      if (!email || !email.includes('@')) {
        return email
      }
      const [name, domain] = email.split('@')
      return `${name.slice(0, 3)}***@${domain}`
    },
    // 卡号掩码：前4 *****后4
    formatCard (num) {
      if (!num) return ''
      const s = String(num)
      if (s.length <= 8) return s
      return `${s.slice(0, 4)}*****${s.slice(-4)}`
    },
    formatedDisplayAddress (address) {
      if (!address) return ''
      const value = address
      if (value.length <= 12) {
        return value
      }
      return `${value.slice(0, 4)}******${value.slice(-4)}`
    },
    switchTab (type) {
      this.tabType = type
      this.page = 1
      this.finished = false
      this.withdrawList = []
      this.listHistory()
    },
    handleScroll (e) {
      const el = e.target
      const scrollTop = el.scrollTop
      const clientHeight = el.clientHeight
      const scrollHeight = el.scrollHeight
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        this.listHistory()
      }
    },
    backToHome () {
      if (window.history.length > 1) {
        if (this.s == 1) {
          this.$router.go(-2)
        } else {
          this.$router.back()
        }
      }
    },

    withdrawCheck () {
      let param = JSON.stringify({})
      postRequest(`/region/withdrawUs/check`, param).then(res => {
        this.showUsdtTab = res.usdt_withdraw_show
        this.showCardTab = res.bankcard_withdraw_enable === true
      })
    },

    listHistory () {
      if (this.loading || this.finished) return
      this.loading = true

      let param = JSON.stringify({
        page: this.page,
        size: this.size,
        paymentType: this.tabType
      })

      postRequest(`/region/withdrawUs/withdrawDetail?region=US`, param)
        .then(res => {
          if (res.code === 0) {
            const records = res.data.records || []
            if (this.page === 1) {
              this.withdrawList = records
            } else {
              this.withdrawList = this.withdrawList.concat(records)
            }
            if (records.length < this.size) {
              this.finished = true
            } else {
              this.page++
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    copy (withdrawId) {
      if (!withdrawId) return
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(withdrawId)
          .then(() => {
            toast('Copied')
          })
          .catch(() => {
            this.fallbackCopy(withdrawId)
          })
      } else {
        this.fallbackCopy(withdrawId)
      }
    },
    // 原静态页引用了未定义的 fallbackCopy，这里补上 execCommand 兜底
    fallbackCopy (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        toast('Copied')
      } catch (e) {
        // 忽略
      }
      document.body.removeChild(textarea)
    }
  },
  created () {
    this.withdrawCheck()
    this.listHistory()
    const s = this.$route.query.s
    if (s) {
      this.s = s
    }
  },
  mounted () {
    // withdrawRem mixin 也有 mounted，Vue 会合并执行，二者互不影响
    this.$refs.scrollBox.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount () {
    if (this.$refs.scrollBox) {
      this.$refs.scrollBox.removeEventListener('scroll', this.handleScroll)
    }
  }
}
</script>

<style scoped>
.no-withdraw {
  height: 2.83rem;
  width: 3.1rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.copy {
  height: .25rem;
  width: auto;
}

.item-data {
  padding-top: .14rem;
  display: flex;
  flex-direction: column;
  gap: .14rem;
  align-items: center;
  width: 100%;
}

.item-data-1 {
  margin: .14rem 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.line {
  margin: .2rem 0;
  margin-top: .04rem;
  width: 100%;
  height: .02rem;
  background: #D8D8D8;
}
.item-2-2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .4rem;
}
.item-2-2-1 {
  font-size: .26rem;
}

.item-2-2-2 {
  font-size: .26rem;
  font-weight: bold;
}

.item-2-1 {
  font-weight: bold;
  font-size: .4rem;
}

.item-2 {
  margin: .1rem 0;
  display: flex;
  padding: 0 .1rem;
  align-items: center;
  justify-content: space-between;
}

.item-f {
  height: .59rem;
  width: auto;
}

.data-item {
  margin: .2rem 0;
  width: calc(100% - .4rem);
  background-color: #ffffff;
  border-radius: .2rem;
  display: flex;
  flex-direction: column;
  padding: .2rem .2rem;
}

.data-container {
  display: flex;
  flex-direction: column;
  gap: .2rem;
  padding: 0.2rem;
  width: calc(100% - .4rem);
}

/* Header */
.header {
  height: 0.88rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem 0.2rem;
  box-sizing: border-box;
  background-color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.left-icon {
  height: 0.3rem;
}

/* Tabs */
.tabs-container {
  display: flex;
  justify-content: space-around;
  margin-top: 0.2rem;
  padding: 0 0.2rem;
  width: calc(100% - .4rem);
}

.tab-item {
  height: 1rem;
  font-size: 0.32rem;
  font-weight: bold;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

.tab-item.active {
  color: #5E44D3;
  font-weight: bold;
  position: relative;
}

.tab-item.active:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
  max-width: 1.2rem;
  height: 0.06rem;
  background: #6c5ce7;
  border-radius: 0.03rem;
}

.title {
  font-size: 0.36rem;
  color: #333;
  font-weight: bold;
}

.placeholder {
  width: 0.44rem;
}

* {
  padding: 0;
  margin: 0;
  color: #1B1B1D;
  font-size: 0.2rem;
}

#withdraw-history {
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  width: 7.2rem;
  max-width: 7.2rem;
  margin: 0 auto;
  background-color: #FCF8FB;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 横屏：内容已由 RotateFrame 旋转成竖屏，铺满旋转框 */
@media screen and (orientation: landscape) {
  #withdraw-history {
    width: 100%;
    max-width: none;
    height: 100%;
    margin: 0;
  }
}
</style>
